import { MyDocs } from '@/modules/my-docs/index.jsx';
import { Files } from '@/modules/files/index.jsx';
import { Shared } from '@/modules/shared/index.jsx';
import { TemplateLibraryPage } from '@/modules/templates/pages/TemplateLibraryPage.jsx';
import { RecordsPage } from '@/modules/records/pages/RecordsPage.jsx';
import { JournalPrintPage } from '@/modules/records/pages/JournalPrintPage.jsx';
import { AgentPanelPage } from '@/modules/assistant/pages/AgentPanelPage.jsx';
import { ConsoleRoute } from '@/app/ConsoleRoute.jsx';

// docs' screens behind sign-in (App.jsx wraps them in SessionGate). `bare`
// pages render without the app's header. The pages nobody signs in to (guest
// links, the QR verification page) and the intent pages, which sign the
// person in themselves, are App.jsx's own routes.
export const routes = [
  {
    // My Docs; `?folder=<uuid>&file=<uuid>` lands in that folder and opens
    // the file (what another module's screen links a person to).
    path: '/my-docs',
    component: MyDocs,
  },
  {
    // One folder of the tree (`:id` is its uuid); `?file=<uuid>` opens a file.
    path: '/files/:id',
    component: Files,
  },
  {
    path: '/shared-docs',
    component: Shared,
  },
  {
    // The template library: templates are the install's, never in the folder
    // tree — managed here, used from the "+ New" picker.
    path: '/templates',
    component: TemplateLibraryPage,
  },
  {
    // The departmental archive: file plans and their cases. The page itself
    // says so when records management is off or the person has no access.
    path: '/records',
    component: RecordsPage,
  },
  {
    // docs' console (settings, API keys, webhooks, indexing, policies,
    // retention, people): install-wide, for whoever administers docs.
    path: '/console',
    component: ConsoleRoute,
  },
  {
    // A journal laid out for paper (`:id`: the register's uuid).
    path: '/records/journals/:id/print',
    component: JournalPrintPage,
    bare: true,
  },
  {
    // Rendered inside the Collabora editor's dock iframe (branding.js loads
    // the URL the editor gives it: `/agent-panel?file=<uuid>`).
    path: '/agent-panel',
    component: AgentPanelPage,
    bare: true,
  },
];
